function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.93 60.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.28,1.35C-.7,3.95-1.64,9.53,2.66,16.8c2.51,4.23,2.72,5.44,2.75,15.64l.03,11.05,4.61,7.95c4.73,8.16,8.55,11.18,11.01,8.72,1.2-1.2.14-4.96-4.23-14.99-1.86-4.27-2.1-5.89-1.33-8.92.51-2.04,1.45-3.88,2.07-4.08,1.52-.5,5.7,6.37,4.78,7.86-.43.7-.29.91.35.51,1.31-.81,2.82,3.81,3.71,11.35.69,5.79,2.67,9.01,5.56,9.01,2.28,0,2.93-2.8,2.95-12.73.01-6.65-.5-9.48-2.66-14.74l-2.67-6.51,2.19-9.54c2.58-11.25,2.17-12.71-4.5-15.65-4.19-1.86-4.63-1.88-6.98-.34-2.29,1.5-2.72,1.51-4.9.07-2.91-1.91-5.93-1.94-10.14-.11",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.22,3.89c3.04,2.39,4.08,2.48,5.73.5,1.75-2.11,5.27-1.87,8.36.57,2.94,2.31,3.12,3.58,1.55,10.89-1.65,7.7-2.8,8.42-12.31,7.62-4.4-.37-8.47-1.07-9.05-1.57-.58-.5-2.38-3.39-4.01-6.44C.83,8.59,1.54,5.06,6.97,3.19c4.59-1.57,4.34-1.6,7.25.69",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.82,25.9h6.62s1.82,5.25,1.82,5.25c2.4,6.89,3.72,17.06,2.99,23.05-.79,6.49-2.43,4.67-3.45-3.82-.76-6.34-4.31-15.09-7.59-18.74-2.39-2.66-6.13-2.24-7.29.82-1.81,4.76-1.11,10.72,1.99,16.96,3.22,6.48,3.74,8.88,1.78,8.23-1.97-.65-6.5-7.73-8.8-13.75-1.74-4.55-1.98-6.67-1.41-12.35l.69-6.86,3.01.6c1.66.33,5.99.61,9.64.62",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg37);
export default __webpack_public_path__ + "static/media/37.d9dea1eb052e9bd923d5ffccb5cbe8f3.svg";
export { ForwardRef as ReactComponent };